import React from 'react';
import { Container, Typography, Link, List, ListItem, ListItemText, Box } from '@mui/material';

function Admissions() {
    return (
        <Container>

            {/* 国内学生向け情報 */}
            <Box mb={4}>
                <Typography variant="h6" gutterBottom>
                    国内学生向け情報
                </Typography>
                <List>
                    <ListItem>
                        <Link href="https://u-aizu.ac.jp/admissions/graduate/schedule/" target="_blank" rel="noopener noreferrer">
                            入試日程
                        </Link>
                    </ListItem>
                </List>
            </Box>

            {/* 国際学生向け情報 */}
            <Box mb={4}>
                <Typography variant="h6" gutterBottom>
                    Information for International Students
                </Typography>
                <List>
                    <ListItem>
                        <Link href="https://u-aizu.ac.jp/en/admissions/graduate/schedule/" target="_blank" rel="noopener noreferrer">
                            Schedule for Admission (EN)
                        </Link>
                    </ListItem>
                    <ListItem>
                        <Link href="https://u-aizu.ac.jp/en/curriculum/internal/international/" target="_blank" rel="noopener noreferrer">
                            International Students Information (University of Aizu)
                        </Link>
                        <List component="div" disablePadding sx={{ pl: 4 }}>
                            <ListItem>
                                    To-do List for Those Moving in/ out
                            </ListItem>
                            <ListItem>
                                    Regarding the Residency Management System
                            </ListItem>
                            <ListItem>
                                    Student Visa and Residence Card
                            </ListItem>
                            <ListItem>
                                    Example of Scholarships
                            </ListItem>
                            <ListItem>
                                    Application for MEXT Scholarship Program (University Recommendation)
                            </ListItem>
                        </List>
                    </ListItem>
                </List>
            </Box>


        </Container>
    );
}

export default Admissions;
